export interface CombustivelDef {
  index: number;
  descricao: string;
  sigla: string;
  cor: string;
}

export const combustiveis: CombustivelDef[] = [
  {
    index: 0,
    descricao: 'Não identificado',
    sigla: '??',
    cor: '#F5F5F5'
  },
  {
    index: 1,
    descricao: 'Gasolina Comum',
    sigla: 'GC',
    cor: '#FA8072'
  },
  {
    index: 2,
    descricao: 'Gasolina Aditivada',
    sigla: 'GA',
    cor: '#B22222'
  },
  {
    index: 3,
    descricao: 'Gasolina Premium',
    sigla: 'GP',
    cor: '#FF0000'
  },
  {
    index: 4,
    descricao: 'Etanol',
    sigla: 'EC',
    cor: '#32CD32'
  },
  {
    index: 5,
    descricao: 'Diesel S10',
    sigla: 'S10',
    cor: '#A020F0'
  },
  {
    index: 6,
    descricao: 'Diesel S500',
    sigla: 'S500',
    cor: '#4B0082'
  },
  {
    index: 7,
    descricao: 'GNV',
    sigla: 'GNV',
    cor: '#B8860B'
  },
];

export function getCombustivelDefBySigla(sigla: string) {
  return combustiveis.find(x => x.sigla === sigla);
}

export function getCombustivelDefByNome(combNome: string) {
  var nome = combNome.removeAcentos().toLocaleLowerCase();

  if (nome.includes("gasolina")) {
    if (nome.includes("aditiv") || nome.includes("grid"))
      return combustiveis[2];

    if (nome.includes("premium") || nome.includes("podium") || nome.includes("racing"))
      return combustiveis[3];

    return combustiveis[1];
  }

  if (nome.includes("etanol") || nome.includes("alcool")) {
    return combustiveis[4];
  }

  if (nome.includes("diesel")) {
    if (nome.includes("aditiv") || nome.includes("10"))
      return combustiveis[5];

    return combustiveis[6];
  }

  if (nome.includes("gnv")) {
    return combustiveis[7];
  }

  return combustiveis[0];
};